import * as React from 'react'

export const ActivityFeedHeaderSeparator = () => {
  return <span className="mx-2.5">&middot;</span>
}
